// extracted by mini-css-extract-plugin
module.exports = {"btn":"BtnShare_btn__3xQn7","btnShare":"BtnShare_btnShare__1GYR1 BtnShare_btn__3xQn7"};